module.exports = __webpack_public_path__ + "img/94.431214c4.jpg";